import { effects } from 'redux-saga'

import { selectSignup } from 'internal-components/src/redux/modules/signup/selectors'
import { replaceCurrentSignup } from '../../modules/signupEdit/actions'

export default function* editSignup(action) {
  const state = yield effects.select()
  const signup = yield effects.call(
    selectSignup,
    state.signup,
    action.payload.id,
  )
  if (!signup) {
    throw new Error(`Signup with ID ${action.payload.id} was not found.`)
  }

  const agreeTerms = state.signupEdit.getIn(['edit', 'agreeTerms'])

  yield effects.put.resolve(
    replaceCurrentSignup(signup, agreeTerms, action.payload.revisit),
  )
}



// WEBPACK FOOTER //
// ./src/redux/sagas/signupEdit/editSignup.js